import { landingApiRequest } from '@/lib/landing-api'

export type VeterinaryVisit = {
  id: string
  campaign_id: number
  payment_id: number | null
  amount_cents: number
  quantity: number
  status:
    | 'creating'
    | 'creation_uncertain'
    | 'pending'
    | 'expired'
    | 'paid'
    | 'failed'
    | 'canceled'
    | 'rejected'
  pix_key: string | null
  expires_at: string | null
  fulfilled_at: string | null
}
export type VeterinaryCatalog = {
  campaign_id: number
  institution_name: string
  quantity: number
  amount_cents: number
  donation_only: boolean
  sales_open: boolean
  visit: VeterinaryVisit | null
  medals: { period: string; visits: number; unlocked: boolean }[]
}
const base = (id: number) => `/api/donor/campaigns/${id}/mascot-veterinary`
export const fetchVeterinaryCatalog = (id: number, signal?: AbortSignal) =>
  landingApiRequest<VeterinaryCatalog>(base(id), { signal, cache: 'no-store' })
export const createVeterinaryVisit = (id: number, requestId: string) =>
  landingApiRequest<VeterinaryVisit>(base(id), {
    method: 'POST',
    body: JSON.stringify({ request_id: requestId }),
  })
export const fetchVeterinaryVisit = (id: number, visitId: string, signal?: AbortSignal) =>
  landingApiRequest<VeterinaryVisit>(`${base(id)}/${encodeURIComponent(visitId)}`, {
    signal,
    cache: 'no-store',
  })
